import React from 'react';
import { Badge } from '@/components/ui/badge';
import { STAGE_STYLE, STAGE_DOT, PAYMENT_STYLE, LEAD_STATUS_STYLE, QUOTE_STATUS_STYLE } from '@/lib/format';
import { cn } from '@/lib/utils';

export function StageBadge({ stage, className, testid }) {
  return (
    <Badge data-testid={testid} variant="outline" className={cn('rounded-full border font-medium', STAGE_STYLE[stage] || 'bg-slate-100 text-slate-700 border-slate-200', className)}>
      <span className={cn('mr-1.5 inline-block h-2 w-2 rounded-full', STAGE_DOT[stage] || 'bg-slate-400')} />
      {stage}
    </Badge>
  );
}

export function PaymentBadge({ status, className, testid }) {
  return (
    <Badge data-testid={testid} variant="outline" className={cn('rounded-full border font-medium', PAYMENT_STYLE[status] || PAYMENT_STYLE['Belum lunas'], className)}>
      {status}
    </Badge>
  );
}

export function LeadBadge({ status, className }) {
  return (
    <Badge variant="outline" className={cn('rounded-full border font-medium', LEAD_STATUS_STYLE[status] || 'bg-slate-100 text-slate-700 border-slate-200', className)}>
      {status}
    </Badge>
  );
}

export function QuoteBadge({ status, className }) {
  return (
    <Badge variant="outline" className={cn('rounded-full border font-medium', QUOTE_STATUS_STYLE[status] || 'bg-slate-100 text-slate-700 border-slate-200', className)}>
      {status}
    </Badge>
  );
}
